module.exports = __webpack_public_path__ + "fonts/montserrat-medium-webfont.3091095.woff2";